import React from 'react'
import { Popover } from 'devextreme-react/popover';
import {Button } from 'reactstrap';
import styles from './aea-tour-popover.module.scss';
import { Enums, Dictionary } from "@utils";

interface IPopoverProps {
	visible: boolean;
    finishTour(): void;
    changeStepTour(step: number): void;
    step: number;
    totalStep: number;
    labelDimension: string;
    followupLabels: Dictionary<string, string>;
    stepPosition: "bottom" | "left" | "right" | "top";
    popOverScroll: ScrollLogicalPosition;
}

const AEAPopOver: React.FC<IPopoverProps> = ({visible, step, labelDimension, followupLabels, totalStep, stepPosition, popOverScroll, finishTour, changeStepTour}: IPopoverProps) => {
    let labelStep = labelDimension + step
    let stepId = labelStep
    if(labelDimension.includes('Indicators') && (step === 16 || step === 6)) stepId = labelDimension + 5
    if(labelDimension.includes('Financial') && (step === 7)) stepId = 'totalResults'
    if(labelDimension.includes('Financial') && (step === 2)) stepId = 'resumeData'
    if(labelDimension.includes('Narrative') && (step === 4)) stepId = Enums.NarrativeReportFields.DesviacionesExplicacion
    if(labelDimension.includes('Narrative') && (step === 8)) stepId = stepId = labelDimension + 2
    if(labelDimension.includes('Beneficiaries') && (step === 13)) stepId = stepId = 'beneficiaries-totals-other-table'

    if(step > 1){
        let objDiv = document.getElementById(`${stepId}`);
        objDiv.scrollIntoView({block: popOverScroll})
        if(!!objDiv){
            return(
                <Popover
                    target={`#${stepId}`}
                    closeOnOutsideClick={false}
                    position={stepPosition}
                    width={500}
                    visible={!!visible}
                    shading={true}
                    shadingColor="rgba(0, 0, 0, 0.5)"
                    className={styles.PopOverContent}
                    >
                        {followupLabels.get(labelStep)}
                        <div className={styles.PopOverActions}>
                            {(step !== totalStep) &&
                                <Button color="link text-gBlue" onClick={() => changeStepTour(step + 1)}>
                                    {followupLabels.get("tourBtnNext")} ({step}/{totalStep})
                                </Button>
                            }
                            <Button
                                color="gBlue"
                                onClick={() => finishTour()}>
                                    {(step === totalStep) ? followupLabels.get("tourBtnFinish") : followupLabels.get("tourBtnSkip")}
                            </Button>
                        </div>
                </Popover>
            )
        }else return <></>
    }else return <></>
}

export default AEAPopOver

